/**
 * Outcome of the ACA PayPal pop-up opened from myQIMA.
 */
export enum EPaypalPopupResult {
  BLOCKED = 'BLOCKED',
  CANCELLED = 'CANCELLED',
  SUCCESS = 'SUCCESS',
}
